import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { TENANT_NAME_PATTERN } from '../../../../shared-types/src/index.js';

interface PartnerCreateFormProps {
  name: string;
  cap: string;
  busy: boolean;
  onNameChange: (value: string) => void;
  onCapChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
}

export function PartnerCreateForm({ name, cap, busy, onNameChange, onCapChange, onSubmit }: PartnerCreateFormProps) {
  const { t } = useTranslation();
  const trimmedName = name.trim();
  const nameError =
    trimmedName && !TENANT_NAME_PATTERN.test(trimmedName) ? t('platform.tenantNameRule') : '';
  return (
    <form className="panel" onSubmit={onSubmit}>
      <h2>{t('partners.createPartner')}</h2>
      <div className="toolbar-form">
        <input
          placeholder={t('partners.name')}
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
          autoComplete="off"
          aria-invalid={Boolean(nameError)}
          aria-describedby="partner-name-rule"
        />
        <p
          id="partner-name-rule"
          className={nameError ? 'error' : 'field-help'}
          role={nameError ? 'alert' : undefined}
        >
          {nameError || t('platform.tenantNameRule')}
        </p>
        <input
          placeholder={t('partners.tenantCapOptional')}
          value={cap}
          inputMode="numeric"
          onChange={(event) => onCapChange(event.target.value)}
          autoComplete="off"
        />
        <button disabled={!trimmedName || Boolean(nameError) || busy}>{t('partners.create')}</button>
      </div>
    </form>
  );
}
